import { useAppSelector } from '../reducers';
import { isAppAuthSelector } from '../selectors/AuthSelectors';
import { useIsPaidPortal } from '../v2/hooks/inventory/useProductInventory';
import { useGlobalLoading } from './loadingHooks';
export const useAddOnsPage = () => {
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const isAppReady = useGlobalLoading();
  const {
    isPaidPortal
  } = useIsPaidPortal();
  const showAddonsPage = isAppReady && isAppAuth && isPaidPortal;
  return {
    showAddonsPage
  };
};